import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RadioButtonComponent } from '../controls/radio-button.component';
import { BaseFieldComponent } from './base-field.component';
import { FieldContainerComponent } from './field-container.component';

@Component({
  selector: 'app-radio-button-field',
  imports: [CommonModule, FieldContainerComponent, RadioButtonComponent],
  template: `
    <app-field-container
      [label]="label"
      [labelCase]="labelCase"
      [labelClasses]="'-tw-mt-1 ' + labelClasses"
      [valueClasses]="valueClasses"
      [control]="control"
    >
      <ng-template #value>
        <app-radio-button
          [options]="options"
          [optionLabel]="optionLabel"
          [optionValue]="optionValue"
          [control]="control"
          [helpText]="helpText"
          [label]="controlLabel"
          [screenReaderLabel]="controlLabel || label"
          [placeholder]="placeholder"
          [showClear]="showClear"
          [showHelpText]="showHelpText"
          [vertical]="vertical"
          [disabled]="disabled"
          [srOnlyLegend]="true"
        ></app-radio-button>
      </ng-template>
    </app-field-container>
  `,
})
export class RadioButtonFieldComponent extends BaseFieldComponent {
  @Input()
  options: any[];

  @Input()
  optionLabel = 'description';

  @Input()
  optionValue = 'value';

  @Input()
  showClear = false;

  @Input()
  vertical = true;

  @Input()
  disabled = false;
}
